import { ActivatedRoute } from '@angular/router'
import { CourtSystem } from '@ftr/contracts/api/court-system'
import { isNotNullOrUndefined } from '@ftr/foundation'
import { Store } from '@ngxs/store'
import { Observable, filter, map, switchMap, tap } from 'rxjs'
import { FetchCourtSystemAction } from '../store/court-systems.actions'
import { CourtSystemsState } from '../store/court-systems.state'

export function getCourtSystemFromRoute(route: ActivatedRoute, store: Store, param: string): Observable<CourtSystem> {
  return route.paramMap.pipe(
    map(paramMap => paramMap.get(param)),
    filter(isNotNullOrUndefined),
    tap(courtSystemId => store.dispatch(new FetchCourtSystemAction(courtSystemId, false))),
    switchMap(courtSystemId => store.select(CourtSystemsState.courtSystemById(courtSystemId))),
    filter(isNotNullOrUndefined),
  )
}
